export default __webpack_public_path__ + "static/media/University of Windsor.3f2a1877.png";